import * as React from 'react';

interface RightArrowCircledIconProps {
    size?: number;
    style?: React.CSSProperties;
}

const RightArrowCircledIcon = (props: RightArrowCircledIconProps) => {
    const size = props.size ?? 16;
    return (
        <svg width={size} height={size} viewBox="0 0 16 16" fill="none" style={props.style}>
            <circle cx="8" cy="8" r="8" fill="currentColor" />
            <path
                d="M8.65079 5.00061L11.5962 8.00061M11.5962 8.00061L8.65079 11.0006M11.5962 8.00061L4.39619 8.00063"
                stroke="white"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default RightArrowCircledIcon;
